/* eslint-disable max-len */

import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, A11y } from 'swiper/modules';

import 'swiper/swiper-bundle.css';

import CompetitionCard from 'components/fragments/card/CompetitionCard';

// @flow
import type { RencontreLiveType } from 'types/Rencontre';
import type { NextMatchType } from 'types/Settings';

export type DispatchProps = {
  fetchRencontresArticle: (ids: string[]) => void
};

export type StateProps = {
  rencontresLive: {
    [key: string]: RencontreLiveType
  },
  rencontresArticle: any[]
};
type Props = DispatchProps &
  StateProps & {
    nextGames: NextMatchType[]
  };

function NextGamesSwiper({ fetchRencontresArticle, nextGames, rencontresArticle, rencontresLive }: Props) {
  useEffect(() => {
    if (nextGames && nextGames.length) {
      const nextGamesIds = nextGames.map(game => game.id);

      fetchRencontresArticle(nextGamesIds);
    }
  }, [nextGames]);

  if (!rencontresArticle || !rencontresArticle.length) {
    return null;
  }

  return (
    <Swiper
      className="next-games--carousel"
      modules={[Autoplay, Navigation, A11y]}
      // spaceBetween={20}
      slidesPerView={'auto'}
      centeredSlides={true}
      watchSlidesProgress={true}
      // loop={rencontresArticle > 2}
      navigation
      autoplay={{
        delay: 2500,
        disableOnInteraction: true
      }}
    >
      {rencontresArticle.sort((a, b) => a.dateEffective - b.dateEffective).map((game, index) => {
        return (
          <SwiperSlide key={game.id}>
            <CompetitionCard key={game.id} lives={rencontresLive} match={game} link={game.lien} upcomingMatch isBig isDark />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default NextGamesSwiper;
